import React, { useCallback, useState } from 'react';
import { Alert, Icon } from 'tea-component';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import { selectValByCondition } from '@home/utils/common';
import './index.scss';

const SESSION_DISMISS_KEY = 'dbh.prWorkspace.prNoticeMarquee.dismissed';

export interface IPrNoticeMarqueeProps {
  textEn: string;
  textZh: string;
}

function readDismissedFromSession(): boolean {
  try {
    return (
      typeof sessionStorage !== 'undefined' &&
      sessionStorage.getItem(SESSION_DISMISS_KEY) === '1'
    );
  } catch {
    return false;
  }
}

/**
 * PR 顶部固定提示（中英文由 pageConfig 传入）；可关闭，关闭状态在同浏览器会话内保持。
 */
const PrNoticeMarquee: React.FC<IPrNoticeMarqueeProps> = (props) => {
  const { textEn, textZh } = props;
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const text = selectValByCondition(isEn, textEn, textZh);

  const [dismissed, setDismissed] = useState(readDismissedFromSession);

  const handleClose = useCallback(() => {
    try {
      sessionStorage.setItem(SESSION_DISMISS_KEY, '1');
    } catch {
      // ignore
    }
    setDismissed(true);
  }, []);

  const closeLabel = isEn ? 'Dismiss notice' : '关闭提示';

  if (dismissed) {
    return null;
  }

  return (
    <div className="dbh-pr-notice-marquee__wrap">
      <Alert type="info" className="dbh-pr-notice-marquee">
        {text}
      </Alert>
      <button
        type="button"
        className="dbh-pr-notice-marquee__close"
        aria-label={closeLabel}
        title={closeLabel}
        onClick={handleClose}
      >
        <Icon type="close" size="s" />
      </button>
    </div>
  );
};

export default PrNoticeMarquee;
